module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av354-bdb74b4914aa23a47595c5b69e82a030.jpg";